<script lang="ts">
    import Icon from '@iconify/svelte'

    import PopEntry from 'hydria/components/PopEntry.svelte'
    import { uuid } from 'hydria/document_helpers'
    import { type TGettext, gettext as _, resolve } from 'hydria/services/gettext'

    interface Props {
        saved: string | undefined | null
        value: string | undefined | null
        disabled?: boolean
        hidden?: boolean
        label: TGettext
        isValid?: any
        unconfiguredText?: TGettext | string | undefined
        emptyIsNull?: boolean
        helpText?: TGettext | undefined
        save?: (v: string | undefined | null) => void
    }

    let { saved: savedValue, value: inValue = $bindable(), disabled = false, hidden = false, label, isValid = (value: string | null) => true, unconfiguredText = undefined, emptyIsNull = true, helpText = undefined, save }: Props = $props()

    let value: string | undefined | null = $state()
    let isOpen = $state(false)

    function open() {
        if (disabled) return
        value = inValue
        isOpen = true
    }
    function close() {
        value = inValue
        isOpen = false
    }
    function keep(v: string | undefined | null) {
        inValue = v == '' && emptyIsNull ? undefined : v
        if (save) save(v)
        isOpen = false
    }

    const id = uuid('t')
    let element: HTMLElement | undefined = $state()

    let savedIsValid = $derived(isValid(savedValue))
    let isPristine = $derived(inValue === savedValue)
    let statusIcon: string = $derived(isPristine ? (savedIsValid ? 'mdi:check-circle' : 'mdi:alert') : isValid(inValue) ? 'mdi:undo' : 'mdi:undo')
    let statusClass: string = $derived(isPristine ? (savedIsValid ? 'btn-link' : 'btn-danger') : isValid(inValue) ? 'btn-outline-warning' : 'btn-outline-danger')
</script>

<svelte:window
    onkeydown={(e) => {
        if (e.key == 'Escape' && isOpen) close()
        else if (e.key == 'Enter' && isValid(value) && isOpen) keep(value)
    }}
/>

{#if !hidden}
    <div class="row g-3 align-items-baseline">
        <div class="col-2 text-end"><label aria-hidden="true" for={id} class="col-form-label" onclick={() => open()}>{$resolve(label)}</label></div>
        <div class="col">
            {#if isOpen}
                <PopEntry
                    close={() => close()}
                    mounted={() => {
                        if (element) element.focus()
                    }}
                >
                    <div class="card">
                        <div class="card-header text-bg-primary">{$resolve(label)}</div>
                        <div class="card-body">
                            <input type="text" class="form-control" bind:value bind:this={element} />
                            {#if helpText != null}
                                <div class="form-text">{$resolve(helpText)}</div>
                            {/if}
                        </div>
                        <div class="card-footer d-flex gap-2 justify-content-end">
                            <button type="button" class="btn btn-sm btn-outline-secondary" onclick={() => close()}>{$_('Fermer')}</button>
                            <button type="button" class="btn btn-sm btn-primary" disabled={!isValid(value)} onclick={() => keep(value)}>{$_('Appliquer')}</button>
                        </div>
                    </div>
                </PopEntry>
            {/if}
            <div aria-hidden="true" onclick={() => open()} class="clickable">
                {#if inValue}
                    {inValue}
                {:else}
                    <em class="text-muted">{unconfiguredText ? $resolve(unconfiguredText) : $_('non-configuré')}</em>
                {/if}
            </div>
            {#if helpText != null}
                <div class="form-text">{$resolve(helpText)}</div>
            {/if}
        </div>
        <div class="col-auto text-end">
            <button
                type="button"
                class="btn btn-sm {statusClass}"
                disabled={isPristine}
                onclick={() => {
                    keep(savedValue)
                }}><Icon inline icon={statusIcon} /></button
            >
            <button type="button" class="btn btn-sm btn-outline-secondary" {disabled} onclick={() => open()}><Icon inline icon="mdi:edit" /></button>
        </div>
    </div>
{/if}
